import { OrganizationRolePolicyDto } from "../../interfaces/superAdmin/SuperAdmin";

export const hasPolicyPermissionV2 = (
  policies: OrganizationRolePolicyDto[] | undefined | null,
  permissionKey: string,
  userAddedInRolePolicy: boolean,
  scope?: string,
  allowLegacy = true,
): boolean => {
  const hasExplicitPermission =
    policies?.some((op) => {
      const matchesKey = op?.policyPermission?.permissionKey === permissionKey;
      const assignedScope = op?.policyPermissionScope?.scope;

      // Access is granted if:
      // 1. No specific scope was requested by the component
      // 2. The requested scope exactly matches the assigned scope
      // 3. The user has the "all" wildcard scope for this permission key
      const matchesScope = 
        !scope || 
        assignedScope === scope || 
        assignedScope === "all";

      return matchesKey && matchesScope;
    }) ?? false;

  const legacyAccess =
    allowLegacy &&
    (policies?.length === 0 || !policies) &&
    !userAddedInRolePolicy;

  return hasExplicitPermission || legacyAccess;
};